/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const BLUEPRINT_CONFIG = {
    Circle: {
        items: [
            {
                backgroundColor: '#2dc937',
                size: 80,
                borderWidth: 8,
                bordercolor: '#000000',
                key: 'green',
            },
            {
                backgroundColor: '#e7b416',
                size: 80,
                borderWidth: 8,
                bordercolor: '#000000',
                key: 'amber',
            },
            {
                backgroundColor: '#cc3232',
                size: 80,
                borderWidth: 8,
                bordercolor: '#000000',
                key: 'red',
            },
        ],
    },
};

export const PRODUCT ={
    title: "",
    subtitle: '',
    qtyKey: 'Vol.',
    qtyValue: '',
    priceKey: 'Price',
    priceValue: '₹ 726.11',
}


export const PRODUCT_IMG =[

    {
        original: 'https://i.ibb.co/563WfWT/DSP-Black.png',
        thumbnail: 'https://i.ibb.co/563WfWT/DSP-Black.png',
        thumbnailHeight: "100",
        thumbnailClass:"image-thumb",
    },
    {
      original: 'https://i.ibb.co/563WfWT/DSP-Black.png',
      thumbnail: 'https://i.ibb.co/563WfWT/DSP-Black.png',
        thumbnailHeight: "100",
        thumbnailClass:"image-thumb",
    },
]


export const PROVENANCE = {
    data: [
      {
        title: '1',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'dispatch',
            title: 'Dispatch',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: '12 May 2021',
          },
          {
            tag: 'dispatch',
            title: 'Dispatch',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: '12 May 2021',
          },
        ],
      },
      {
        title: '2',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'mrwFinishedGood',
            title: 'MRW Finished Good',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: '24 May 2021',
          },
          {
            tag: 'bottling',
            title: 'Bottling',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: '24 May 2021',
          },
        ],
      },
      {
        title: '3',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'blending',
            title: 'Blending',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
        ],
      },
      {
        title: '4',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'hbs',
            title: 'HBS',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: '14 May 2021',
          },
          {
            tag: 'bms',
            title: 'Blended Malt Spirit(BMS)',
            subtitle: ' MH',
            date: '14 May 2021',
          },
        ],
      },
      {
        title: '5',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'maturation',
            title: 'Maturation',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'ms12',
            title: 'Malt Spirit MS S 12',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'mss02',
            title: 'Malt Spirit MS S 02',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
        ],
      },
      {
        title: '6',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'distillation',
            title: 'Distillation',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'cmms',
            title: 'CMMS (MS  C18)',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'lowWineMalt',
            title: 'LOW WINE - MALT',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'washMalt',
            title: 'WASH - MALT',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'wortMalt',
            title: 'WORT - MALT',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
        ],
      },
      {
        title: '7',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'malting',
            title: 'Malting',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
        ],
      },
      {
        title: '8',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'malting',
            title: 'Malting',
            subtitle: 'United ',
            date: 'DD MMM YYYY',
          },
        ],
      },
      {
        title: "8",
        subtitle: "LEVEL",
        data: [
          {
            tag: "malting",
            title: "Malting",
            subtitle: "WASH - MALT",
            date: 'DD MMM YYYY',
           
          }
        ]
      },
      {
        title: '9',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'malting',
            title: 'Malting',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
        ],
      },
    ],
  };


  export const FEEDBACK_BUTTON ={
    title:"Feedback"
  }

  export const PROMO_BUTTON ={
    title:"Visit"
  }

  export const MODAL_FEEDBACK_CARD ={
    title: "feedback",
    prodImage: "https://i.ibb.co/563WfWT/DSP-Black.png",
    prodTitle: "Director's special black whisky",
    prodSubTitle: "Premium extension of Director's Special Whisky",
    prodPrice: "726.11",
  
  }

